import { render, staticRenderFns } from "./ChartPieComponent.vue?vue&type=template&id=4796a6de&scoped=true&"
import script from "./ChartPieComponent.vue?vue&type=script&lang=js&"
export * from "./ChartPieComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChartPieComponent.vue?vue&type=style&index=0&id=4796a6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796a6de",
  null
  
)

export default component.exports